<form [formGroup]="formFilter">
  <mat-form-field appearance="outline" class="w-100">
    <ngx-spinner  name="spUsuarioEmpresa" [zIndex]="-1" bdColor="rgba(255,255,255,0.8)" size="small"
      color="var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>

    <mat-label>{{label}}</mat-label>

    <mat-select formControlName="EmpresaUsuario" placeholder="Seleccione usuario" [(value)]="usuarioEmpresaIngresado"
      (selectionChange)="onUsuarioChange($event.value)">
      <mat-option *ngFor="let usuarioSummary of empresaUsuarios; trackBy: trackByUsuario" [value]="usuarioSummary">

        <div class="user-option">
          <div class="user-main">

            <app-avatar-iniciales [size]="'sm'"  [nombre]='usuarioSummary.usuario?.nombre '
              [apellido]='usuarioSummary.usuario?.apellido'
              [activo]='usuarioSummary.usuario?.activo'></app-avatar-iniciales>


            <div class="user-info">
              <div class="user-name">
                {{ usuarioSummary.usuario?.nombre }} {{ usuarioSummary.usuario?.apellido }}
              </div>
              <div class="user-email">
                {{ usuarioSummary.usuario?.correo }}
              </div>
            </div>
            <span class="user-status" [ngClass]="usuarioSummary.usuario?.activo ? 'activo' : 'inactivo'">
              ● {{ usuarioSummary.usuario?.activo ? 'Activo' : 'Inactivo' }}
            </span>
          </div>
        </div>
      </mat-option>

      <mat-select-trigger>
        {{ usuarioEmpresaIngresado?.usuario?.nombre }} {{ usuarioEmpresaIngresado?.usuario?.apellido }}
      </mat-select-trigger>
    </mat-select>
  </mat-form-field>
</form>
